// extracted by mini-css-extract-plugin
module.exports = {"welcomeMessage":"WelcomeDialog_welcomeMessage__2Bb7m"};